
import FaqItem from './-faq-item.vue'
import Pagination from '@/components/pagination/index.vue'

export default {
  name: 'FaqList',
  components: { FaqItem, Pagination },
  props: {
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    allowToggleAll: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      paginat: {},
      isAllUnfolded: true,
      list: this.dataSource,
    }
  },
  computed: {
    // 切换全部展开、全部折叠状态
    toggleAllText() {
      return this.isAllUnfolded
        ? this.$t('button.expandAll')
        : this.$t('button.collapseAll')
    },
  },
  watch: {
    dataSource(val) {
      this.list = val
    },
    pagination: {
      handler(val) {
        this.paginat = val
      },
      immediate: true,
      deep: true,
    },
    type() {
      this.isAllUnfolded = true
      this.$emit('changeFolded', this.isAllUnfolded)
    },
  },
  mounted() {
    // this.list = this.dataSource
  },
  methods: {
    toggleAll() {
      this.isAllUnfolded = !this.isAllUnfolded
      this.$emit('changeFolded', this.isAllUnfolded)
      this.list.forEach((i) => {
        this.$set(i, 'folded', this.isAllUnfolded)
      })
    },
    change(value) {
      if (value) {
        this.$emit('change', value)
      }
    },
  },
}
